export const options = [
  { label: "1er arrastre", value: "1er arrastre" },
  { label: "2do arrastre", value: "2do arrastre" },
  { label: "3er arrastre", value: "3er arrastre" },
  { label: "4to arrastre", value: "4to arrastre" },
  { label: "Km recorrido", value: "km recorrido" },
  { label: "Banderazo", value: "Banderazo" },
  { label: "Maniobras fuera de camino", value: "Maniobras fuera de camino" },
  { label: "Maniobras dentro del camino", value: "Maniobras dentro del camino" },
  { label: "Abanderamiento con grúa", value: "Abanderamiento con grúa" },
  { label: "Abanderamiento manual", value: "Abanderamiento manual" },
  { label: "Acondicionamiento", value: "acondicionamiento" },
  { label: "Custodia", value: "Custodia" },
  { label: "Pensión", value: "Pensión" },
  { label: "Concesionado no ubica unidad", value: "Concesionado no ubica unidad" },
  { label: "Casetas (escotel)", value: "Casetas (escotel)" },
  { label: "Casetas (corporativo)", value: "Casetas (corporativo)" },
  { label: "Carga", value: "Carga" },
  { label: "Extracción", value: "Extracción" },
  { label: "Uso Dollys - Patines", value: "Uso Dollys - Patines" },
  { label: "Desfleche", value: "Desfleche" },
  { label: "Desparqueo", value: "Desparqueo" }
];

export const opcionesQuienPaga = [
  { label: "Escotel", value: "Escotel" },
  { label: "Usuario Final", value: "Usuario Final" },
  { label: "Cliente Corporativo", value: "Cliente Corporativo" },
];

export const opcionesIVA = [0, 8, 16].map(value => ({label: `${value}%`, value}));
export const opcionesIVARetenido = [0, 4, 10.6667].map(value => ({label: `${value}%`, value}));
export const opcionesISRRetenido = [0, 10].map(value => ({label: `${value}%`, value}));
